import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as PlusIcon } from '../../../../assets/icons/plus.svg';

interface AddCardButtonProps {
  onClick: () => void;
}

export default function AddCardButton({ onClick }: AddCardButtonProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <button
      onClick={onClick}
      type="button"
      className="flex flex-col justify-center items-center gap-3 border-2 border-dashed rounded-xl border-gray-300 dark:border-slate-600 bg-gray-50 dark:bg-slate-800/50 p-4 w-[220px] h-[128px] text-sm text-gray-600 dark:text-gray-400 hover:border-orange dark:hover:border-teal-500 hover:bg-orange/5 dark:hover:bg-teal-500/5 hover:text-orange dark:hover:text-teal-400 transition-all duration-200"
    >
      <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-slate-700 flex items-center justify-center">
        <PlusIcon className="w-5 h-5" />
      </div>
      <span className="font-medium">{t('account:payments.addCard.title')}</span>
    </button>
  );
}
